export const fonts: Fonts = {
  heading: `'aktiv-grotesk', sans-serif`,
  body: `'aktiv-grotesk', sans-serif`,
  mono: 'LinearSans, Noto Sans, Arial, Helvetica, sans-serif',
};

export type Fonts = {
  heading: string;
  body: string;
  mono: string;
};
